<div class="container vw-100">
  <form [formGroup]="ScreeningFrom" (ngSubmit)="onSubmit($event)">
    @for (question of rawQuestions; track question) {
      <div>
        <div class="card my-5 shadow">
          <div class="card-header">
            <h6 class="card-title whitespace">
              {{ question.question }}
            </h6>
          </div>
          <div class="card-body">
            @if (question.type === 'radio') {
              <div class="form-check">
                @for (answer of question.answers; track answer) {
                  <div class="form-check">
                    <input
                      type="radio"
                      [value]="answer"
                      [formControlName]="question.questionID"
                      [id]="question.questionID + '_' + answer"
                      class="form-check-input"
                      />
                    <label [for]="question.questionID + '_' + answer" class="form-check-label">
                      {{ answer }}
                    </label>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </form>
  <div>
    <button
      class="btn btn-primary mb-3 me-4"
      type="submit"
      (click)="onSubmit($event)"
      [disabled]="!ScreeningFrom.valid || isLoading"
      >
      Next
    </button>
    @if (isLoading) {
      <span class="loader"></span>
    }
  </div>
</div>
